import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { BookmarksProvider } from './context/BookmarksContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Navbar } from './components/Navbar';
import { AdBanner } from './components/AdBanner';

// Pages
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { SubscribePage } from './pages/SubscribePage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { DashboardPage } from './pages/DashboardPage';
import { SanctionDetailPage } from './pages/SanctionDetailPage';
import { AdminPage } from './pages/AdminPage';
import { AccountPage } from './pages/AccountPage';
import { BookmarksPage } from './pages/BookmarksPage';
import { ContactPage } from './pages/ContactPage';
import { CorporatePage } from './pages/CorporatePage';

import './App.css';

const PageWithAd = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <div className="flex-1">{children}</div>
    <AdBanner />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BookmarksProvider>
          <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<PageWithAd><Navbar /><LandingPage /></PageWithAd>} />
            <Route path="/login" element={<PageWithAd><LoginPage /></PageWithAd>} />
            <Route path="/register" element={<PageWithAd><RegisterPage /></PageWithAd>} />
            <Route path="/forgot-password" element={<PageWithAd><ForgotPasswordPage /></PageWithAd>} />
            <Route path="/reset-password" element={<PageWithAd><ResetPasswordPage /></PageWithAd>} />
            <Route path="/contact" element={<PageWithAd><Navbar /><ContactPage /></PageWithAd>} />
            <Route path="/corporate" element={<PageWithAd><Navbar /><CorporatePage /></PageWithAd>} />
            
            {/* Protected routes - require auth */}
            <Route 
              path="/subscribe" 
              element={<PageWithAd><ProtectedRoute><SubscribePage /></ProtectedRoute></PageWithAd>} 
            />
            <Route 
              path="/payment-success" 
              element={<PageWithAd><PaymentSuccessPage /></PageWithAd>}
            />
            <Route 
              path="/subscription" 
              element={<PageWithAd><ProtectedRoute><SubscriptionPage /></ProtectedRoute></PageWithAd>} 
            />
            <Route 
              path="/account" 
              element={<PageWithAd><ProtectedRoute><AccountPage /></ProtectedRoute></PageWithAd>} 
            />
            <Route 
              path="/bookmarks" 
              element={<PageWithAd><ProtectedRoute requireSubscription><BookmarksPage /></ProtectedRoute></PageWithAd>} 
            />
            
            {/* Protected routes - require subscription */}
            <Route 
              path="/dashboard" 
              element={<PageWithAd><ProtectedRoute requireSubscription><DashboardPage /></ProtectedRoute></PageWithAd>} 
            />
            <Route 
              path="/sanctions/:id" 
              element={<PageWithAd><ProtectedRoute requireSubscription><SanctionDetailPage /></ProtectedRoute></PageWithAd>} 
            />
            
            {/* Admin routes */}
            <Route 
              path="/admin" 
              element={<PageWithAd><ProtectedRoute requireAdmin><AdminPage /></ProtectedRoute></PageWithAd>} 
            />
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </BookmarksProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
